import React, {useEffect, useState} from "react";
import 'animate.css';

import classNames from "classnames";
import {SVGCheck} from "../../assets/svg/SVGCheck";
import {TextContent} from "../course/TextContent";


export function QuestionOption(props) {

    const [clicked, setClicked] = useState(false);
    const [multipleChoiceDone, setMultipleChoiceDone] = useState(false);

    const ANSWER_TIMEOUT = 1000;
    const SELECTED_AND_CORRECT = "SELECTED_AND_CORRECT"
    const SELECTED_AND_WRONG = "SELECTED_AND_WRONG"
    const UNSELECTED_AND_CORRECT = "UNSELECTED_AND_CORRECT"
    const letterIndex = ["A", "B", "C", "D"]

    useEffect(() => {}, [props.multipleChoiceFinished, props.option])

    function getOptionState() {
        let selected = false;
        for (let i = 0; i < props.displayAnswers.length; i++) {
            if(props.displayAnswers[i].id === props.option.id) {
                selected = true;
            }
        }

        if(selected && props.option.correct) {
            return SELECTED_AND_CORRECT;
        }

        if(selected && !props.option.correct) {
            return SELECTED_AND_WRONG
        }

        if(!selected && props.option.correct) {
            return UNSELECTED_AND_CORRECT
        }
    }

    function renderDisplayOption() {

        if(props.disabled && props.displayAnswers != null) {
            const state = getOptionState()


            switch (state) {
                case SELECTED_AND_CORRECT:
                    return (
                        <span className={"text-success ms-3"}>
                            <SVGCheck size={24}/>
                        </span>
                    );
                case SELECTED_AND_WRONG:
                    return (
                        <span className={"text-danger ms-3"}>
                            <strong className={"m-0"}>X</strong>
                        </span>
                    );
                case UNSELECTED_AND_CORRECT:
                    return (
                        <span className={"text-secondary ms-3"}>
                            <SVGCheck size={24}/>
                        </span>
                    );
                default:
                    return (
                        <div>

                        </div>
                    );
            }
        }


    }


    const optionClass = classNames("btn btn-light d-flex align-items-center border mb-3 py-3 text-start w-100", {
        'bg-success':clicked && props.option.correct,
        'text-white':clicked && props.option.correct,
        'animate__animated animate__rubberBand':clicked && props.option.correct,
        'bg-danger':clicked && !props.option.correct,
        'animate__animated animate__tada':clicked && !props.option.correct,
        'disabled':props.disabled
    })

    const optionClassMpc = classNames("btn btn-light border  mb-3 py-3 text-start d-flex align-items-center w-100", {
        'bg-success':props.multipleChoiceFinished && clicked && props.option.correct,
        'text-white':props.multipleChoiceFinished && clicked && props.option.correct,
        'animate__animated animate__rubberBand':props.multipleChoiceFinished && clicked && props.option.correct,
        'bg-danger':props.multipleChoiceFinished && clicked && !props.option.correct,
        'animate__animated animate__tada':props.multipleChoiceFinished && clicked && !props.option.correct,
        'disabled':props.disabled
    })


    if(props.option != null) {


        if(props.multipleChoice) {
            return (
                <div className={optionClassMpc} onClick={() => {
                    props.selectOptionCallback(props.option)
                    setClicked(!clicked)
                }}>

                    <input className={"form-check-input me-4"} style={{width:"2vw", height:"2vw"}} type={"checkbox"} checked={clicked}/>
                    <label className={"form-check-label"}> {props.option.text}</label>
                    {
                        renderDisplayOption()
                    }
                </div>
            );
        } else {
            return (
                <div className={"row"}>
                    <div className={"col"}>

                        <button className={optionClass} onClick={() => {
                            props.selectOptionCallback(props.option)
                            setClicked(true);
                            setTimeout(() => {
                                setClicked(false)
                                props.nextQuestionCallback()
                            }, ANSWER_TIMEOUT);
                        }}> <strong className={"me-3 ms-2"}>{letterIndex[props.index] + "."}</strong>
                            <TextContent value={props.option.text} level={0}/>
                            {renderDisplayOption()}</button>
                    </div>




                </div>

            );
        }
    }



}